import { css } from 'linaria';
import { ButtonGroupProps, Variables } from '../index';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --main-bg-color: ${Variables.css.catapultWhite};
            --color: ${Variables.css.catapultBlack};
            --selected-bg-color: ${Variables.css.catapultBlack};
            --selected-color: ${Variables.css.catapultWhite};
        }

        [data-theme='dark'] {
            --main-bg-color: ${Variables.css.catapultBlack};
            --color: ${Variables.css.catapultWhite};
            --selected-bg-color: ${Variables.css.catapultWhite};
            --selected-color: ${Variables.css.catapultBlack};
        }
    }
`;
export const UnstyledButton = css`
    all: unset;
`;

export const toggleGroupContainer = css`
    display: inline-flex;
    border-radius: ${Variables.css.spacing4};
    width: auto;
`;

export const stretchedToggleGroupContainer = css`
    display: inline-flex;
    border-radius: ${Variables.css.spacing4};
    width: 100%;
`;

export const firstChildHorizontal = css`
    border-top-left-radius: ${Variables.css.spacing4};
    border-bottom-left-radius: ${Variables.css.spacing4};
`;

export const lastChildHorizontal = css`
    border-top-right-radius: ${Variables.css.spacing4};
    border-bottom-right-radius: ${Variables.css.spacing4};
`;

export const firstChildVertical = css`
    border-top-left-radius: ${Variables.css.spacing4};
    border-top-right-radius: ${Variables.css.spacing4};
`;

export const lastChildVertical = css`
    border-bottom-left-radius: ${Variables.css.spacing4};
    border-bottom-right-radius: ${Variables.css.spacing4};
`;

export const toggleGroupItem = css`
    background-color: var(--main-bg-color);
    color: var(--color);
    display: flex;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--color);
    margin-left: -2px; //space out to allow separation of buttons
    cursor: pointer;
    box-sizing: content-box;

    [data-theme='light'] &:hover:not([data-state='on']):not([disabled]) {
        background: rgba(16, 16, 16, 0.04);
    }

    [data-theme='dark'] &:hover:not([data-state='on']):not([disabled]) {
        background: rgba(255, 255, 255, 0.08);
    }

    [data-theme='light'] &:hover:active:not([disabled]),
    [data-theme='light'] &:hover:focus-visible:not([disabled]) {
        background: rgba(16, 16, 16, 0.12);
        color: var(--color);
    }

    [data-theme='dark'] &:hover:active:not([disabled]),
    [data-theme='dark'] &:hover:focus-visible:not([disabled]) {
        background: rgba(255, 255, 255, 0.32);
        color: var(--color);
    }

    &[data-state='on'] {
        background-color: var(--selected-bg-color);
        color: var(--selected-color);
    }

    &[disabled] {
        cursor: not-allowed;
    }

    &[disabled]::before {
        border: 2px var(--color);
        opacity: 1;
    }

    &[disabled] * {
        opacity: 0.5;
    }

    &:focus-visible {
        border-radius: ${Variables.css.spacing4};
        box-shadow: 0 0 0 4px ${Variables.css.focusRing};
        outline: none;
        z-index: 100;
    }

    &:first-child {
        margin-left: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
`;

export const sizes: Record<ButtonGroupProps['size'], string> = {
    medium: css`
        min-height: 40px;
        min-width: 40px;
        padding: 0px;
    `,
    small: css`
        min-height: 24px;
        min-width: 24px;
        padding: 0px;
    `,
};
export const stretched: Record<ButtonGroupProps['size'], string> = {
    medium: css`
        min-height: 40px;
        width: 100%;
    `,
    small: css`
        min-height: 24px;
        width: 100%;
    `,
};
